import _ from 'lodash';

import tpl from './infomodal.tpl.html';
import './infomodal.component.scss';
import uibModalModule from 'angular-ui-bootstrap/src/modal';

import { noop } from "../../../common/common.utils";
import {serviceURL} from '../../../common/common.urls';
import Service from "../../models/service.model";
import tabBarComponent from '../../../../common/material-components/tabs/tab-bar.component';
import normalButtonComponent from '../../../../common/material-components/buttons/norm-button.component';
import iconButtonComponent from '../../../../common/material-components/buttons/icon-button.component';
import generalInfoCompMod from '../info/general-info.component';

class InfoModalComponent {
  constructor($uibModalInstance, $log, objects, templates, titles, showAvailableTimesButton, callback) {
    'ngInject';
    this.$log = $log;

    if (objects == null || !Array.isArray(objects)) {
      $log.warn("Provide list of objects to display");
    }
    if (templates == null || !Array.isArray(templates)) {
      $log.warn("Provide list of templates to display");
    }
    if (objects.length !== templates.length) {
      $log.warn("Provide same number of objects and templates to display");
    }
    if (objects.length > 1 && (titles == null || objects.length !== titles.length)) {
      $log.warn("You should provide the same number of objects, templates and titles");
    }

    this.objs = objects;
    this.obj = this.objs[0];

    this.templates = templates;
    this.activeTpl = templates[0];
    this.hasTabs = false;

    this.$uibModalInstance = $uibModalInstance;

    if (titles != null && titles.length > 0) {
      this.tabs = titles.map(t => {
        return {title: t};
      });
      this.tabs[0].active = true;
      this.hasTabs = true;
    }

    this.showAvailableTimesButton = showAvailableTimesButton;

    if (_.isFunction(callback)) {
      callback();
    }
  }

  tabSelected(index) {
    this.activeTpl = this.templates[index];
    this.$log.debug("Selected tab", index, "Template:", this.activeTpl);
    this.obj = this.objs[index];
  }


  selectObject() {
    this.$uibModalInstance.close(this.obj);
  }

  close() {
    this.$uibModalInstance.dismiss();
  }

  /**
   * Get a WP URL for object based on the object
   */
  objectUrl() {
    if (this.obj instanceof Service) {
      return this.obj.url.length > 0 ? this.obj.url : serviceURL(this.obj);
    }
    else {
      return '#';
    }
  }
}

const infoModalConfig = {
  size: 'lg',
  controller: InfoModalComponent,
  controllerAs: '$ctrl',
  templateUrl: tpl,
  animation: false,
};

const mod = angular.module('app.common.infoModal', [
  uibModalModule, tabBarComponent, normalButtonComponent,
  iconButtonComponent, generalInfoCompMod
])
  .factory('InfoModal', function ($uibModal) {
    return (objects, tpls, titles, showAvailableTimesButton = true, callback = noop) => {
      infoModalConfig.resolve = {
        objects: () => {
          return objects;
        },
        templates: () => tpls,
        titles: () => titles,
        showAvailableTimesButton: () => showAvailableTimesButton,
        callback: () => callback,
      };
      return $uibModal.open(infoModalConfig);
    };
  });


export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/components/infomodal/infomodal.component.js